import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import FOG from "vanta/dist/vanta.fog.min";
import "../../App.css";
import About from "./About";

export default function Services() {
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null);

  useEffect(() => {
    if (!vantaEffect.current) {
      vantaEffect.current = FOG({
        el: vantaRef.current,
        THREE: THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        highlightColor: 0x8500ff, // Purple tone
        midtoneColor: 0xff1f00,
        lowlightColor: 0x2d00ff,
        baseColor: 0xffebeb,
        blurFactor: 1, // 👈 controls fog softness (0.1–1.0 typical range)
        speed: 1.2,      // controls fog motion speed
        zoom: 0.5  
      });
    }

    // Cleanup on unmount
    return () => {
      if (vantaEffect.current) vantaEffect.current.destroy();
    };
  }, []);

  return (
    <div>
      <div
        ref={vantaRef}
        className="services d-flex justify-content-center align-items-center text-white"
        style={{
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          width:"98%", marginLeft:"auto", marginRight:"auto", borderRadius:"25px", top: "-40px",
        }}
      >
        <h1 className="fw-bold" style={{ zIndex: 2 }}>
          ABOUT
        </h1>
      </div>

      <br />
      <About />
    </div>
  );
}
